import { Box, Divider, styled } from '@mui/material';

export const PriceRow = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
}));

export const DashedDivider = styled(Divider)(() => ({
	borderStyle: 'dashed',
}));
